<template>
	<div class="cms-divider-block" :style="containerStyle">
		<hr class="cms-divider-block__line" :style="hrStyle" />
	</div>
</template>

<script>
/**
 * DividerBlock.vue
 * ────────────────
 * A horizontal rule / divider with configurable style, width, height, and color.
 * Alignment is a wrapper style trait: the line is inline-block so the
 * wrapper's text-align positions it inside the block height.
 */

export default {
	name: 'DividerBlock',

	props: {
		lineStyle: {
			type: String,
			default: 'solid',
			validator: function (v) { return ['solid', 'dashed', 'dotted'].indexOf(v) !== -1; }
		},
		lineWidth: { type: String, default: '100%' },
		lineThickness: { type: String, default: '1px' },
		height: { type: String, default: '1rem' },
		color: { type: String, default: '#DDDEE0' }
	},

	computed: {
		containerStyle: function () {
			return {
				minHeight: this.height,
				lineHeight: this.height
			};
		},
		hrStyle: function () {
			return {
				width: this.lineWidth,
				maxWidth: '100%',
				borderTop: this.lineThickness + ' ' + this.lineStyle + ' ' + this.color,
				margin: 0
			};
		}
	}
};
</script>

<style scoped>
.cms-divider-block {
	width: 100%;
	max-width: 100%;
	text-align: inherit;
	font-size: 0;
}
.cms-divider-block__line {
	display: inline-block;
	vertical-align: middle;
	border: none;
	height: 0;
}
</style>
